import { useApiMonOrga } from '~/composables/api/useApiMonOrga'

type DirectionAdminContactRef = {
  nni: string
  dirLib: string
  dirLibLong: string | null
}

export type OrgAccessStatusResponse = {
  managerUnplaced: boolean
  adminWithoutDirectionScope: boolean
  directionAdminContactRefs: DirectionAdminContactRef[]
  /** Toutes les affectations admin de direction (aligné API, souvent identique à `directionAdminContactRefs`). */
  allDirectionAdminAssignments?: DirectionAdminContactRef[]
  superAdminContactRefs: { nni: string }[]
}

export function useOrgAccessStatus() {
  const { loggedIn, user } = useOidcAuth()
  const orgAccessStatus = useState<OrgAccessStatusResponse | null>(
    'monorga.orgAccessStatus',
    () => null
  )

  async function refreshOrgAccessStatus(): Promise<void> {
    if (import.meta.server) {
      return
    }
    try {
      orgAccessStatus.value = await useApiMonOrga<OrgAccessStatusResponse>(
        'GET',
        '/v1/me/org-access-status'
      )
    } catch (error) {
      orgAccessStatus.value = null
      console.error('Impossible de récupérer le statut d’accès org', error)
    }
  }

  watch(
    () => ({ isLoggedIn: loggedIn.value, accessToken: user.value?.accessToken }),
    async ({ isLoggedIn, accessToken }) => {
      if (import.meta.server) {
        return
      }
      if (!isLoggedIn || !accessToken) {
        orgAccessStatus.value = null
        return
      }
      await refreshOrgAccessStatus()
    },
    { immediate: true }
  )

  return {
    orgAccessStatus,
    refreshOrgAccessStatus,
  }
}
